if (!window.aqSizeGuideReady) {
  window.aqSizeGuideReady = true;
  document.addEventListener('click', function(event) {
    const opener = event.target.closest('[data-aq-guide-open]');
    if (opener) {
      const drawer = opener.closest('#quick-add-dialog')
        ? document.getElementById('aq-size-guide-quick-add')
        : document.getElementById(opener.getAttribute('aria-controls')) || opener.closest('.product-details')?.querySelector('dialog.aq-size-drawer');
      if (drawer && !drawer.open) { event.preventDefault(); opener.setAttribute('aria-controls', drawer.id); drawer.showModal(); }
      return;
    }
    const close = event.target.closest('[data-aq-guide-close]');
    if (close) { close.closest('dialog').close(); return; }
    const toggle = event.target.closest('[data-aq-unit]');
    if (toggle) {
      const drawer = toggle.closest('.aq-size-drawer');
      const unit = toggle.dataset.aqUnit;
      drawer.querySelectorAll('[data-aq-unit]').forEach(button => button.setAttribute('aria-pressed', String(button === toggle)));
      drawer.querySelectorAll('[data-aq-cm]').forEach(cell => {
        cell.textContent = unit === 'cm' ? cell.dataset.aqCm : cell.dataset.aqCm.split(/[–−-]/).map(value => (Number(value.trim()) / 2.54).toFixed(1)).join('–');
      });
      drawer.querySelector('[data-aq-current-unit]').textContent = unit;
      return;
    }
    if (event.target.matches('dialog.aq-size-drawer')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
}